import { tryLoadDependencies, WebAwesomeComponent } from '../Global/loadDependecy'
import { TemplateControlInfoStyles } from './ControlInfo.styles'
import { getBootstrapIconUrl, BootstrapIcon } from '../Global/icons'

const svgInfo = getBootstrapIconUrl(BootstrapIcon.InfoCircle)

const t = document.createElement('template')
t.innerHTML = `
<wa-dialog id="dialog">
  <label slot="label">
    <slot name="dialog-label"></slot>
  </label>
  <slot name="dialog-content"></slot>
  <wa-button id="btn-close" slot="footer" variant="brand">Close</wa-button>
</wa-dialog>
<wa-button id="btn-open" size="small" appearance="plain"><wa-icon slot="start" src="${svgInfo}"></wa-icon>
<slot></slot>
</wa-button>
`
const TemplateControlInfo = t

class ControlInfo extends HTMLElement {
  constructor() {
    super()

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(TemplateControlInfoStyles.content.cloneNode(true))
    shadow.appendChild(TemplateControlInfo.content.cloneNode(true))
  }

  connectedCallback() {
    console.log('ControlInfo connectedCallback')

    tryLoadDependencies(document, [WebAwesomeComponent.Dialog, WebAwesomeComponent.Button])

    const dialog = this.shadowRoot?.getElementById('dialog') as HTMLElement
    const btnOpen = this.shadowRoot?.getElementById('btn-open')

    btnOpen?.addEventListener('click', () => {
      dialog?.setAttribute('open', 'true')
    })

    const btnClose = this.shadowRoot?.getElementById('btn-close')
    btnClose?.addEventListener('click', () => {
      dialog?.removeAttribute('open')
    })
  }
}

if (!customElements.get('ts-control-info')) {
  customElements.define('ts-control-info', ControlInfo)
}
export { ControlInfo }
